import { useState } from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import { Box } from "@mui/material";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { v4 as uuid } from "uuid";

import { deepCopyObject } from "../../utils/helpers.js";
import Checkbox from "../ui/omniCheckbox";
import OmniDatePicker from "../ui/omniDatePicker";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";
import OmniResponsiveButton from "../ui/omniResponsiveButton.js";
import OmniTextField from "../ui/omniTextField";
import AlertDialog from "./alertDialog";

const PatientMotivationDialog = props => {
  const {
    open,
    dialogTitle = "Motivation",
    dialogMessage = null,
    textLabel = "Motivation",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    deleteMessage = "delete",
    maxWidth = "xs",
    fullWidth = true,
    rowCount = 8,
    motivationODM,
  } = props;

  // const [editedValues] = useState(deepCopyObject(motivationODM));
  const [openGoal, setOpenGoal] = useState(motivationODM.omniSchedule.scheduleEndDate == null);
  const [motivationNote, setMotivationNote] = useState(motivationODM.omniData.note);
  const [motivationTitle, setMotivationTitle] = useState(motivationODM.omniData.title);
  const [userPlannedCompletionDate, setUserPlannedCompletionDate] = useState(new Date(Date.now()));

  const [showConfirm, setShowConfirm] = useState(false);

  const onAcceptHandler = () => {
    let newMotivation = deepCopyObject(motivationODM);
    newMotivation.omniData.note = motivationNote;
    newMotivation.omniData.title = motivationTitle;
    if (openGoal) {
      newMotivation.omniSchedule.userPlannedCompletionDate = null;
    } else {
      newMotivation.omniSchedule.userPlannedCompletionDate = userPlannedCompletionDate;
    }
    // editedValues.omniSchedule.scheduleStartDate = scheduleStartDate;
    // editedValues.omniSchedule.scheduleEndDate = scheduleEndDate;
    // editedValues.omniSchedule.completionDate = completionDate;
    props.onAccept(newMotivation);
  };

  const onDeleteHandler = () => {
    props.onDelete(motivationODM);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        {dialogMessage && <DialogMessage>{dialogMessage}</DialogMessage>}
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <FormControl component="fieldset" sx={{ minWidth: "124px", marginTop: "8px" }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    color="secondary"
                    checked={openGoal}
                    onChange={() => setOpenGoal(!openGoal)}
                    name="openGoal"
                  />
                }
                label="Open Goal"
              />
            </FormGroup>
          </FormControl>
          <OmniDatePicker
            label="Target Date"
            value={userPlannedCompletionDate}
            name={uuid()} //prevents AutoComplete Suggestions
            onAccept={null}
            onChange={date => setUserPlannedCompletionDate(date)}
            format="MM/dd/yyyy"
            disabled={openGoal}
            disablePast={true}
            fullWidth
          />
        </Box>
        <OmniTextField
          label="Motivation"
          type="textInput"
          name={uuid()}
          variant="outlined"
          value={motivationTitle}
          onChange={event => {
            setMotivationTitle(event.target.value);
          }}
          placeholder={textLabel}
        />
        <OmniTextField
          label="Motivation Note"
          type="textInput"
          name={uuid()}
          variant="outlined"
          value={motivationNote}
          onChange={event => {
            setMotivationNote(event.target.value);
          }}
          placeholder={textLabel}
          multiline
          rows={rowCount}
        />
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between">
          <Grid item xs={6}>
            {motivationODM._id != null && (
              <OmniResponsiveButton
                icon={<DeleteIcon />}
                onClick={() => setShowConfirm(true)}
                buttonText={deleteMessage}
                tooltipTitle=""
              />
            )}
          </Grid>
          <Grid container item justifyContent="flex-end" xs={6} spacing={1}>
            <Grid item>
              {cancelMessage && (
                <Button onClick={onCloseHandler} color="secondary" variant="contained">
                  {cancelMessage}
                </Button>
              )}
            </Grid>
            <Grid item>
              <Button
                onClick={onAcceptHandler}
                color="secondary"
                disabled={motivationTitle.length === 0}
                variant="contained"
              >
                {okMessage}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogActions>

      {showConfirm && (
        <AlertDialog
          open={showConfirm}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want to delete this personal motivation?"}
          onAccept={() => {
            onDeleteHandler();
            setShowConfirm(false);
          }}
          onClose={() => {
            setShowConfirm(false);
          }}
        />
      )}
    </Dialog>
  );
};

export default PatientMotivationDialog;
